<template>
<v-layout row wrap mt-4>
  <v-flex md3>
    <!-- <img src="https://zerohunger.nohup.it/images/placeholder.svg" style="
width: 200px;
margin: 10px;
"> -->

    <!-- <patientPhoto></patientPhoto> -->


  </v-flex>
  <!-- form Fields -->
  <v-flex md9>
    <v-form id="registration">
      <v-layout>
        <v-flex md3>
          <v-select v-bind:items="items" v-model="select" label="Select" data-vv-name="select" required></v-select>
        </v-flex md3>
        <v-flex md9>
          <v-text-field label="Full Name" v-model="fullname" required></v-text-field>
        </v-flex md9>
      </v-layout>
      <v-text-field label="Mobile Number" v-model="mobile" required></v-text-field>
      <v-layout row>
        <v-flex md9>
          <v-radio-group v-model="gender" :mandatory="true" row>
            <v-radio label="Male" value="Male"></v-radio>
            <v-radio label="Female" value="Female"></v-radio>
            <v-radio label="Other" value="Other"></v-radio>
          </v-radio-group>
        </v-flex md9>
        <v-flex md3>
          <v-text-field label="Age" v-model="age" required></v-text-field>
        </v-flex md3>
      </v-layout>
      <!-- PLACE -->
      <v-layout row>
        <v-flex md6>
          <!-- <v-text-field label="Place" v-model="place" required></v-text-field> -->
          <!-- <vue-google-autocomplete v-model="place" id="map" classname="form-control" placeholder="Place" :country="['in']" types="geocode" v-on:placechanged="getAddressData"> -->
          <!-- </vue-google-autocomplete> -->
        </v-flex md6>
        <v-flex md6>
          <v-text-field label="Aadhaar" v-model="aadhar"></v-text-field>
        </v-flex md6>
      </v-layout>
      <!-- AADHAAR -->
      <v-layout row>
        <!-- <v-flex md6>
            <v-text-field label="Aadhaar" v-model="aadhaar" required></v-text-field>
          </v-flex md6> -->
        <v-flex md6>
          <!-- <v-text-field label="Appointment" v-model="appointment"></v-text-field> -->
          <!-- <el-date-picker v-model="appointmentDate" type="date" placeholder="Pick a day" format="yyyy/MM/dd" value-format="yyyy-MM-dd" defaultTime=''> -->
          </el-date-picker>
        </v-flex md6>
        <v-flex md6>
          <!-- <v-text-field label="Appointment" v-model="appointment"></v-text-field> -->
          <!-- <el-time-select v-model="appointmentTime" placeholder="Pick a time" format="HH:mm:ss"> -->
          <!-- </el-time-select> -->
        </v-flex md6>
      </v-layout>
      <!-- EMERGENCY NAME -->
      <v-layout row>
        <v-flex md6>
          <v-text-field label="Emergency Name" v-model="ecyName" required></v-text-field>
        </v-flex md6>
        <v-flex md6>
          <v-text-field label="Emergency Number" v-model="ecyNumber" required></v-text-field>
        </v-flex md6>
      </v-layout>
      <!-- doctor_reference and descriptive_notes -->
      <v-layout row>
        <v-flex md6>
          <v-text-field label="Referred by" v-model="doctor_reference" required></v-text-field>
        </v-flex md6>
        <v-flex md6>
          <v-text-field label="Descriptive Notes" v-model="descriptive_notes" required></v-text-field>
        </v-flex md6>
      </v-layout>


      <!-- submit -->
      <v-btn @click="submit">
        submit
      </v-btn>
    </v-form>
    <!-- form Fields -->
  </v-flex md9>
</v-layout>
</div>
</template>
<script>
import { api } from '../api.js';
import { axios, get, post } from 'axios';
// import patientPhoto from './VueWebcam';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
export default {
  name: 'NewRegistration',
  components: {
    // patientPhoto,
    VueGoogleAutocomplete
  },
  data() {
    return {
      address: '',
      photo: null,
      selectedTab: 'tab-1',
      tabs: [
        {
          id: 1,
          name: 'ONE'
        },
        {
          id: 2,
          name: 'TWO'
        }
      ],
      select: null,
      items: ['Mr.', 'Dr.', 'Mrs.', 'Miss.', 'Ms.', 'Master.', 'Baby.', 'Mx.'],
      fullname: '',
      mobile: '',
      gender: 'Male',
      age: null,
      place: 'shankar',
      aadhar: '',
      appointment: '',
      ecyName: '',
      ecyNumber: '',
      descriptive_notes: '',
      doctor_reference: '',
      appointmentDate: '',
      appointmentTime: '',
      editBasicId: '',
      editAddressId: '',
      editEmerId: '',
      editPhoneId: '',
      edit: ''
    };
  },
  mounted() {
    // this.$refs.address.focus();
    this.getProfileDetails();
  },
  methods: {
    getProfileDetails() {
      const person_id = this.$route.params.ptId;
      get(api + `/v2/profile/${person_id}`).then(res => {
        console.log(res.data);
        const r = res.data.profile;
        const fullNamess = r.basic_info.name;
        const nameSplit = fullNamess.split('.');
        this.fullname = nameSplit[1];
        if (nameSplit[0].length > 0) {
          this.select = nameSplit[0] + '.';
        } else {
          this.select = 'Mr.';
        }
        // this.fullname = r.basic_info.name
        // this.select = nameSplit[0]
        this.mobile = r.phone_number[0].number;
        this.gender = r.basic_info.sex;
        this.age = r.basic_info.age;
        // this.place = r.addresses[0].city
        this.aadhar = r.basic_info.aadhar;
        this.ecyName = r.emergency[0].name;
        this.ecyNumber = r.emergency[0].number;
        this.doctor_reference = r.basic_info.doctor_reference;
        this.descriptive_notes = r.basic_info.descriptive_notes;
        this.editBasicId = r.basic_info.id;
        this.editAddressId = r.addresses[0].id;
        this.editEmerId = r.emergency[0].id;
        this.editPhoneId = r.phone_number[0].id;
      });
    },
    getAddressData(addressData, placeResultData, id) {
      this.address = placeResultData.name;
      console.log(addressData);
      console.log(placeResultData);
      console.log(id);
    },
    take_photo() {
      this.photo = this.$refs.webcam.getPhoto();
    },
    submit() {
      const newName = this.select + this.fullname;
      const appointmentDateTime =
        this.appointmentDate + ' ' + this.appointmentTime;
      let obj = {
        basic_info: {
          name: newName,
          age: this.age,
          sex: this.gender,
          aadhaar: this.aadhaar,
          doctor_reference: this.doctor_reference,
          descriptive_notes: this.descriptive_notes
        },
        addresses: [{ city: this.address, id: this.editAddressId }],
        phone_number: [{ name: '', number: this.mobile }],
        emergency: [{ number: this.ecyNumber, name: this.ecyName }]
      };

      let reqBody = {
        phone_number: [
          {
            id: this.editPhoneId,
            name: '',
            number: this.mobile
          }
        ],
        basic_info: {
          id: this.editBasicId,
          name: newName,
          age: this.age,
          aadhar: this.aadhar,
          doctor_reference: this.doctor_reference,
          descriptive_notes: this.descriptive_notes,
          sex: this.gender
        },
        emergency: [
          {
            id: this.editEmerId,
            name: this.ecyName,
            number: this.ecyNumber
          }
        ]
      };
      // let obj={basic_info:{"name":newName,"age":this.age,"sex":this.gender,"aadhaar":this.aadhaar,"doctor_reference":this.doctor_reference,"descriptive_notes":this.descriptive_notes},addresses:[{"city":this.address}],phone_number:[{"name": "","number":this.mobile}],emergency:[{"number":this.ecyNumber,"name":this.ecyName}],image:{"url":"https://nfnlabs.in/images/logo_nav.jpg",}}
      var myJSON = JSON.stringify(obj);
      // console.log(myJSON);
      // console.log(appointmentDateTime);
      console.log(reqBody);

      post(api + `/v2/registration`, reqBody).then(res => {
        console.log(res.data);
        // post(api + `appointments?doctor_id=${doctor_id}&time=${this.appointmentDate+ " " + this.appointmentTime}&place=${this.address}&is_waiting=1&person_id=${res.data.person_id}`)
        console.log(
          api +
            `appointments?doctor_id=28&time=${this.appointmentDate +
              ' ' +
              this.appointmentTime}&place=${
              this.address
            }&is_waiting=1&person_id=${res.data.person_id}`
        );
      });

      // AJAX POST
      //
      // $.ajax({
      //   url: api+'/registration',
      //   type: "POST",
      //   data: myJSON,
      //   contentType: "application/json; charset=utf-8",
      //   dataType: "json",
      //   success: function() {
      //     console.log(response.message);
      //   }
      // });
    }
  }
};
</script>
<style scoped>
#registration [class*='md'] {
  margin-right: 0.5rem;
}

#map {
  box-shadow: none;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  margin-right: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/components/NewRegistrationEdit.vue